import {
    useEffect, useState,
} from 'react'
import {
    GridRowSelectionModel,
} from '@mui/x-data-grid-pro'

import {
    INIT_SELECTION_MODEL,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/constants'

/* Hook to handle row selection logic for details page */
function useObjectProfileRowSelectionModel(id: string) {
    const [
        rowSelectionModel,
        setRowSelectionModel,
    ] = useState<GridRowSelectionModel>(INIT_SELECTION_MODEL)

    /* this will sync selected row with if from route */
    useEffect(() => {
        setRowSelectionModel((oldRowSelectionModel: GridRowSelectionModel) => {
            if (!id) {
                return INIT_SELECTION_MODEL
            }
            const newRowSelectionModel = {
                ...oldRowSelectionModel,
                ids: new Set([Number(id)]),
            }

            return newRowSelectionModel
        })
    }, [id])

    return {
        rowSelectionModel,
        onRowSelectionModelChange: undefined,
    }
}

export default useObjectProfileRowSelectionModel
